import { Grid, Alert as MuiAlert, IconButton, Typography } from '@mui/material'
import { LastRecordedTransactionSnapshot } from './DepositFundForm'

import CloseIcon from '@mui/icons-material/Close'
import { formatCurrency } from '../../../utils'

interface FirmPaymentSuccessMessageProps {
  info: LastRecordedTransactionSnapshot
  onClose: () => void
}

const FirmPaymentSuccessMessage = ({ info, onClose }: FirmPaymentSuccessMessageProps) => {
  return (
    <Grid item xs={12}>
      <MuiAlert
        severity="success"
        action={
          <IconButton size="small" aria-label="close" onClick={onClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      >
        <Typography variant="body2" component="div" fontWeight={600} color="text.primary">
          Firm payment recorded successfully
        </Typography>
        <Typography variant="body1" component="div" color="text.secondary">
          <strong>Destination account:</strong> {info.destinationAccountLabel}. <strong>Payment method:</strong>{' '}
          {(info.paymentMethod || '').replace(/CHEQUE/g, 'CHECK')}. <strong>Amount:</strong>{' '}
          {formatCurrency(info.amount)}.
        </Typography>
      </MuiAlert>
    </Grid>
  )
}

export default FirmPaymentSuccessMessage
